const payment = () => import('@views/payment')
const paymentMember = () => import('@views/payment/member/index')

const routes = [
  {
    path: '/payment',
    component: payment,
    name: 'payment',
    meta: { title: '', first: false, resourceCode: '', keepAlive: true },
    children: [
      {
        path: 'member',
        component: paymentMember,
        name: 'paymentMember',
        meta: { keepAlive: true }
      }
    ]
  }
]

export default {
  routes
}



// WEBPACK FOOTER //
// ./src/router/payment/index.js